module.exports = __webpack_public_path__ + "bc6cb140072af5b41e6dc150228f8735.png";